import { TabCommunicationEvent } from './TabCommunication.ts';
export class TabCommunicationLocalStorage {
    sendEvent(event) {
        const eventKey = this.STORAGE_KEY_PREFIX + TabCommunicationEvent[event];
        localStorage.setItem(eventKey, Date.now().toString());
        localStorage.removeItem(eventKey);
    }
    onEvent(event, callback) {
        this.eventCallbacks.set(event, callback);
    }
    constructor(){
        this.STORAGE_KEY_PREFIX = 'tab_communication_event_';
        this.eventCallbacks = new Map();
        window.addEventListener('storage', (event)=>{
            if (!event.key) return;
            if (!event.key.startsWith(this.STORAGE_KEY_PREFIX)) return;
            const eventName = event.key.slice(this.STORAGE_KEY_PREFIX.length);
            const tabEvent = TabCommunicationEvent[eventName];
            const callback = this.eventCallbacks.get(tabEvent);
            callback === null || callback === void 0 ? void 0 : callback();
        });
    }
}
